<template>
    <client-page>
        <guide-visual v-bind="visual" />

        <div class="client-content-wrap">
            <scrolldown-tail />

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="section-title">물품후원 효과</h2>
                    </div>

                    <v-row>
                        <v-col v-for="(effect, index) in effects" :key="index" cols="6" lg="3">
                            <v-card color="#ddd" max-width="282" outlined class="border-radius-16 mx-auto text-center h-100">
                                <v-img :src="effect.image" alt=""></v-img>
                                <v-card-title class="justify-center pt-lg-40">
                                    <h4 class="tit tit--sm primary--text">
                                        {{ effect.title }}
                                    </h4>
                                </v-card-title>
                                <v-card-text class="pb-lg-40">
                                    <p v-html="effect.texts" class="page-text page-text--lg" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="section-title">후원가능 물품</h2>
                    </div>

                    <goods-tabs />
                </v-container>
            </section>

            <section class="client-section">
                <a href="https://secure.donus.org/withcan/pay/step1?_gl=1*1csn9b9*_ga*MTA5ODMyNDAzLjE3MjE4MTAwODU.*_ga_1KFQVNYJMP*MTc0Mjk2Mzc5OS4yMi4xLjE3NDI5NjU5ODYuNTkuMC4w" target="_blank">
                    <v-img src="/images/guide/goods/mobile-banner.jpg" alt="" class="d-md-none" />
                </a>
                <div class="d-none d-md-block">
                    <v-card tile flat img="/images/guide/goods/banner.jpg" class="banner">
                        <v-container>
                            <p class="page-text page-text--lg white--text mb-12 mb-lg-16">With You, With Can</p>
                            <h2 class="banner__title font-aggro white--text">
                                <p>
                                    당신과 함께라면, 저소득층에게 <br />
                                    더 많은 희망을 전할 수 있습니다.
                                </p>
                            </h2>
                            <contact-dialog business="물품후원">
                                <template #activator="{ on, attrs }">
                                    <v-btn v-on="on" v-bind="attrs" color="white" large rounded="pill" class="mt-20 mt-md-40">
                                        <span class="font-size-18 font-size-md-20 font-aggro mb-n4 primary--text w-lg-160px text-center">후원하기</span>
                                        <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            </contact-dialog>
                            <!-- <v-btn href="https://secure.donus.org/withcan/pay/step1?_gl=1*1csn9b9*_ga*MTA5ODMyNDAzLjE3MjE4MTAwODU.*_ga_1KFQVNYJMP*MTc0Mjk2Mzc5OS4yMi4xLjE3NDI5NjU5ODYuNTkuMC4w" target="_blank" color="white" large rounded="pill" class="mt-20 mt-md-40">
                                <span class="font-size-18 font-size-md-20 font-aggro mb-n4 primary--text w-lg-160px text-center">후원하기</span>
                                <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                            </v-btn> -->
                        </v-container>
                    </v-card>
                </div>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="section-title">물품후원 안내</h2>
                    </div>

                    <v-img src="/images/guide/goods/process-list.png" alt="" class="d-md-none" />

                    <div class="d-none d-md-block">
                        <v-row class="process-list row--lg">
                            <v-col v-for="(item, index) in process" :key="index" cols="12">
                                <v-card color="#FAFAFA" flat class="process-card">
                                    <v-row class="text-center">
                                        <v-col cols="12">
                                            <div class="primary--text font-weight-bold font-size-28">0{{ index + 1 }}</div>
                                            <div v-html="item.name" class="client-title--xs font-weight-bold my-24" />
                                            <p v-html="item.text" class="page-text page-text--lg" />
                                            <v-img :src="`/images/guide/goods/progress-${index + 1}.svg`" max-width="60" class="mt-28 mx-auto" />
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="text-center mt-40 mt-lg-80">
                        <contact-dialog business="물품후원">
                            <template #activator="{ on, attrs }">
                                <v-btn v-on="on" v-bind="attrs" large color="primary" rounded="pill">
                                    물품후원 신청하기
                                    <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                </v-btn>
                            </template>
                        </contact-dialog>
                        <!-- <p class="page-text page-text--lg grey-1--text mt-24">전화문의 : 02-2057-2296 이메일 문의 : 미정</p> -->
                    </div>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="section-title">자주 묻는 질문</h2>
                    </div>

                    <faq-list :items="faq" />
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import GuideVisual from "@/components/client/guide/guide-visual.vue";
import ClientPage from "../templates/ClientPage.vue";
import ScrolldownTail from "@/components/dumb/scrolldown-tail.vue";
import SponsorSlide from "@/components/client/dumb/sponsor-slide.vue";
import GoodsTabs from "@/components/client/guide/goods-tabs.vue";
import Faq from "../board/community/Faq.vue";
import FaqList from "@/components/client/dumb/faq-list.vue";
import ContactDialog from "@/components/client/dumb/contact-dialog.vue";

export default {
    components: {
        ClientPage,
        GuideVisual,
        ScrolldownTail,
        SponsorSlide,
        GoodsTabs,
        Faq,
        FaqList,
        ContactDialog,
    },
    data() {
        return {
            visual: {
                image: "/images/guide/goods/visual.jpg",
                title: "물품후원",
                texts: "가치있는 물품 후원, 희망을 전하는 첫걸음입니다.",
                mobile: "/images/guide/goods/mobile-visual.jpg",
            },

            effects: [
                {
                    image: "/images/guide/goods/effect-1.jpg",
                    title: "ESG 경영 실천",
                    texts: "기업의 사회적 책임을 다하여 <br class='d-none d-lg-block' />지역의 소외된 이웃을 돕고 <br class='d-none d-lg-block' />환경을 보호합니다.",
                },
                {
                    image: "/images/guide/goods/effect-2.jpg",
                    title: "취약계층 지원",
                    texts: "도움이 필요한 취약계층에게 <br class='d-none d-lg-block' />가장 필요한 물품을 지원합니다.",
                },
                {
                    image: "/images/guide/goods/effect-3.jpg",
                    title: "세제 혜택",
                    texts: "지정기부금 단체로 <br class='d-none d-lg-block' />기부금 영수증 발행이 가능하며, <br class='d-none d-lg-block' />세제 감면 혜택을 받을 수 있습니다",
                },
                {
                    image: "/images/guide/goods/effect-4.jpg",
                    title: "선한 영향력",
                    texts: "기업 나눔 스토리와 언론보도 등을 <br class='d-none d-lg-block' />통해 후원 기업의 이미지 제고와 <br class='d-none d-lg-block' />홍보가 가능합니다.",
                },
            ],

            process: [
                {
                    name: "후원문의",
                    text: "품목, 수량 등 후원 물품의 <br class='d-none d-xl-block' />정보작성 및 신청",
                },
                {
                    name: "접수 및 협의 ",
                    text: "문의내용 토대로 최종 <br class='d-none d-xl-block' />후원 가능 여부 협의",
                },
                {
                    name: "물품 기부",
                    text: "후원물품 <br class='d-none d-xl-block' />발송 및 입고",
                },
                {
                    name: "기부금 영수증 발행 ",
                    text: "검수 이후 기부금 <br class='d-none d-xl-block' />영수증 발행",
                },
                {
                    name: "지원 및 판매 ",
                    text: "취약계층 직접 지원 및 <br class='d-none d-xl-block' />나눔가게 판매",
                },
            ],

            faq: [
                {
                    Q: "최소 기부 수량이 정해져있나요?",
                    A: "최소 기부 수량은 정해져 있지 않으며, 1개를 후원해주셔도 후원자님의 마음을 담아 도움이 필요한 이웃에게 지원하고 있습니다.",
                },
                {
                    Q: "중고물품도 기부 가능한가요?",
                    A: "새상품만 기부가 가능하며, 중고물품은 기부가 불가능합니다.",
                },
                {
                    Q: "기부금 영수증 발행이 가능한가요?",
                    A: "후원물품 도착 후 검수 확인과 함께 기부금 영수증 발행이 가능하며, 연말정산 간소화서비스를 통해 확인 가능합니다.",
                },
                {
                    Q: "기부금 영수증 발행시 기부가액 산정은 어떻게 되나요?",
                    A: "물품을 직접 구매하신 경우 증빙자료(세금계산서, 카드영수증, 현금영수증 등)를 보내주시면 기재된 금액으로 산정됩니다. 구입영수증을 제출하지 않은 경우, 위드캔복지재단 장부가액확인서 작성을 통해 기부가액 산정됩니다.",
                },
                {
                    Q: "기부물품은 어떻게 사용되나요?",
                    A: "위드캔복지재단 산하시설을 통해 노인, 아동청소년, 한부모가정 등의 취약계층에 1차 배분되며, 후원자의 동의를 얻은 물품에 한해 나눔가게, 바자회 등을 통해 판매되어 수익금으로 취약계층을 위한 복지사업에 사용됩니다.",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.banner {
    aspect-ratio: 16/9;
    display: flex;
    align-items: center;
    padding: 20px 0;
    &__title {
        font-size: 28px;
        font-weight: 500;
    }
}
.process-list {
    > [class*="col"] {
        .process-card {
            padding: 40px 16px;
            height: 100%;
            border-radius: 16px;
            max-width: 400px;
            margin: 0 auto;
            word-break: keep-all;
        }
        &:not(:last-child) {
            .process-card {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 50%;
                    bottom: -28px;
                    transform: translateX(50%) rotate(90deg);
                    width: 24px;
                    height: 24px;
                    background: url(/images/guide/temporary/process-arrow.svg) no-repeat center;
                }
            }
        }
    }
}
@media (min-width: 768px) {
    .banner {
        aspect-ratio: 1920/600;
        &__title {
            font-size: 36px;
        }
    }
}
@media (min-width: 1024px) {
    .process-list {
        > [class*="col"] {
            flex-basis: 20%;
            &:not(:last-child) {
                .process-card {
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        right: -32px;
                        bottom: 50%;
                        transform: translatey(50%);
                        width: 24px;
                        height: 24px;
                        background: url(/images/guide/temporary/process-arrow.svg) no-repeat center;
                    }
                }
            }
        }
    }
}
</style>